import { useRecoilValue } from "recoil";
import { permanentDataAtom } from "recoil/permanentDataAtom";

// 네이티브 앱이 RN-Web 메시지로 알려주는 디바이스 정보.
// 안전영역(home indicator) 은 CSS env(safe-area-inset-*) 로 자동 처리되므로 포함하지 않음.
export default function useGetDeviceInfo() {
  const permanantDataState = useRecoilValue(permanentDataAtom);

  const appVersion = permanantDataState?.appVersion || "1.0.0";
  return {
    appVersion,
  };
}
